import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  CircleSmallLogo,
  HelpIcon,
  ManualsIcon,
  PoweredByLogo,
  TermsLogo,
  PrivacyLogo,
} from "../assets/Sidebar";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { useTranslation } from "react-i18next";
import { openHelp } from "../../../Redux/reducers/helpSlice";
import HelpManualDrawer from "../../Help/HelpManualDrawer";
import { featuresMap } from "../../../utils/features";
import { platformAdminPermissions } from "../../../utils/roles";

const VersionDetails = () => {
  const { t } = useTranslation("sidebar");

  return (
    <Box sx={{ px: 2, pt: 2, pb: 0.5 }}>
      <Divider />
      <Typography
        variant="body1"
        fontWeight={"medium"}
        color="gray"
        fontSize={12}
        sx={{ textAlign: "center", mt: 2 }}
      >
        {`${t("VERSION_LABEL")} 5.0.43 (31/08/2026)`}
      </Typography>
    </Box>
  );
};

const VersionWrapper = ({
  participant,
  isPlatform,
}: {
  participant?: boolean;
  isPlatform?: boolean;
}) => {
  const collapsed = useAppSelector((state) => state.app.collapsed);
  const features = useAppSelector((state) => state.study.features);
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions,
  );
  const { t } = useTranslation("sidebar");
  const dispatch = useAppDispatch();
  const showManuals = isPlatform
    ? platformPermissions.includes(platformAdminPermissions.viewPlatform)
    : !!features?.[featuresMap.userManual];

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const navigateToLink = (type: string) => {
    setAnchorEl(null);
    if (type === "terms") {
      window.open("https://www.mahalo.health/privacy-policy", "_blank");
    } else if (type === "manuals" && !participant) {
      dispatch(openHelp(undefined));
    } else {
      window.open("https://mahalo.gitbook.io/mahalo-docs", "_blank");
    }
  };

  return (
    <Box>
      <Divider />
      <Box className="sider-menu" onClick={openMenu}>
        <HelpIcon />
        {!collapsed && (
          <Typography variant="subtitle1" ml={1}>
            {t("HELP")}
          </Typography>
        )}
      </Box>
      {!collapsed && (
        <>
          <Divider />
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              mt: 2,
              ml: 2,
            }}
          >
            {participant ? <CircleSmallLogo /> : <PoweredByLogo />}
            <Typography variant="body1" fontWeight={"medium"} color="gray">
              {t("POWERED_BY_MAHALO")}
            </Typography>
          </Box>
        </>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            mt: -1.5,
          },
        }}
      >
        <MenuItem onClick={() => navigateToLink("terms")}>
          <ListItemIcon>
            <PrivacyLogo />
          </ListItemIcon>
          <ListItemText sx={{ color: "#6B7280" }}>
            {t("PRIVACY_POLICY")}
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={() => navigateToLink("terms")}>
          <ListItemIcon>
            <TermsLogo />
          </ListItemIcon>
          <ListItemText sx={{ color: "#6B7280" }}>
            {t("TERMS_OF_USE")}
          </ListItemText>
        </MenuItem>
        {showManuals && (
          <MenuItem onClick={() => navigateToLink("manuals")}>
            <ListItemIcon>
              <ManualsIcon />
            </ListItemIcon>
            <ListItemText sx={{ color: "#6B7280" }}>
              {t("MANUALS")}
            </ListItemText>
          </MenuItem>
        )}
        <VersionDetails />
      </Menu>
      {!participant && <HelpManualDrawer isPlatform={!!isPlatform} />}
    </Box>
  );
};

export default VersionWrapper;
